module.exports = __webpack_public_path__ + "media/event_deer-intro.78597cb9.mp3";